export default __webpack_public_path__ + "static/programme - TDD, DDD et Clean Architecture - Kotlin - 20012025-d859a61a9757516eec4dea67bc3b6c69.pdf";